import { render } from "./Digitalizzazione.vue?vue&type=template&id=6bcb714e&scoped=true"
import script from "./Digitalizzazione.vue?vue&type=script&lang=js"
export * from "./Digitalizzazione.vue?vue&type=script&lang=js"

import "./Digitalizzazione.vue?vue&type=style&index=0&id=6bcb714e&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bcb714e"]])

export default __exports__